module.exports = __webpack_public_path__ + "static/img/jp1-4.5e99001.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/jp1-4.png
// module id = 915
// module chunks = 0